// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const roselia: PokeData = {
  "id": 315,
  "name": "roselia",
  "height": 3,
  "weight": 20,
  "base_experience": 140,
  "types": [
    PokeType.GRASS,
    PokeType.POISON
  ],
  "api_moves": [
    "poison-sting",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "poison-powder",
    "stun-spore",
    "petal-dance",
    "toxic",
    "giga-drain",
    "sweet-scent",
    "synthesis",
    "ingrain",
    "aromatherapy",
    "grass-whistle",
    "magical-leaf",
    "worry-seed",
    "toxic-spikes",
    "poison-jab",
    "energy-ball",
    "venoshock",
    "petal-blizzard"
  ],
  "moves": [
    "poison-powder",
    "stun-spore",
    "synthesis",
    "aromatherapy",
    "toxic-spikes",
    "poison-jab",
    "energy-ball",
    "flower-rush",
    "solar-beam",
    "sludge-bomb",
    "acid-rain",
    "branch-poke",
    "poison-gas"
  ],
  "evolution_chain": {
    "id": 158,
    "item": {
      "name": "rose-incense"
    },
    "species": [
      {
        "name": "budew",
        "order": 341,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "roselia",
        "order": 342,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 406,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "roserade",
        "order": 343,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 315,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "shiny-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 65,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
